import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { QUIZ_QUESTIONS } from "@/lib/quiz";

const QS = QUIZ_QUESTIONS.filter(q => ["hands_on", "work_location", "country"].includes(q.id));

export const QuizExtraCard = ({ onSaved }) => {
  const [show, setShow] = useState(false);
  const [ans, setAns] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/quiz").then(r => {
      const q = r.data.quiz || {};
      if (q.hate_level != null && (!q.hands_on || !q.work_location || !q.country)) { setShow(true); setAns({ hands_on: q.hands_on, work_location: q.work_location, country: q.country }); }
    }).catch(() => {});
  }, []);

  if (!show) return null;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/quiz/extra", ans);
      setShow(false);
      toast.success("Got it. Your matches are updated.");
      onSaved?.();
    } catch { toast.error("Couldn't save. Try again."); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-5 card-panel-elevated p-5 border-[#FD0F10]/40" data-testid="quiz-extra-card">
      <div className="eyebrow text-[#FD0F10]">2 QUICK QUESTIONS</div>
      <p className="text-sm text-gray-300 mt-1">Answer these so your matches fit you even better.</p>
      {QS.map(q => (
        <div key={q.id} className="mt-4">
          <div className="text-white font-bold text-sm">{q.title}</div>
          <div className="mt-2 flex flex-wrap gap-2">
            {q.options.map(o => (
              <button key={o.value} type="button" onClick={() => setAns(a => ({ ...a, [q.id]: o.value }))} data-testid={`quiz-extra-${q.id}-${o.value}`}
                className={`text-left px-3 py-2.5 rounded-lg border text-sm transition-colors ${ans[q.id] === o.value ? "border-[#FD0F10] bg-[#FD0F10]/10 text-white" : "border-[#2A2E39] bg-[#14161B] text-gray-200 hover:border-[#FD0F10]/50"}`}>
                {o.label}
              </button>
            ))}
          </div>
        </div>
      ))}
      <button onClick={save} disabled={busy || !ans.hands_on || !ans.work_location || !ans.country} className="mt-4 hero-accent text-white font-bold px-5 py-2.5 rounded disabled:opacity-50" data-testid="quiz-extra-save">
        {busy ? "Saving…" : "Update my matches"}
      </button>
    </div>
  );
};
